import type { ReactNode } from 'react'

/** A monochrome 24×24 line icon (currentColor) — the header and workspace-bar
 *  glyphs; `children` are its shapes. */
export function LineIcon({ size, children }: { size: number; children: ReactNode }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {children}
    </svg>
  )
}
